



























import { Component, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobStatus from '@/models/Jobs/JobStatus';
import JobStatusSetClosed from '@/components/Jobs/JobStatusSetClosed.vue';
import UpdateJobStatusRequest from '@/models/Jobs/UpdateJobStatusRequest';

@Component({
    name: 'JobStatusSet',
    components: { JobStatusSetClosed }
})
export default class extends GiganautVueDialog {
 
  jobStatus = JobStatus;

  menu = false;

  get job() {
    return JobDetailsModule.currentJob;
  }

  async setStatusToOpen() {
    const request = new UpdateJobStatusRequest();
    request.updatedAt = JobDetailsModule.currentJob.updatedAt;
    request.status = JobStatus.Open;
    await JobDetailsModule.updateJobStatus(request);
  }
}
